import React, { Component, ErrorInfo, ReactNode } from 'react';
import ErrorView from 'src/components/atomic/pages/error/ErrorView';
import { RouteComponentProps, withRouter } from 'react-router';
import TrackingService from 'src/services/tracking.service';
import { ApiError } from 'src/utils/error.utils';
import LogoutService from 'src/services/logout.service';
import { getSpendsmartLandingPageUrl } from 'src/utils/url.utils';

interface Props extends RouteComponentProps {
    reset: () => void;
    isMobileApp: boolean;
    children?: ReactNode;
}

interface State {
    error: Error;
}

class ErrorBoundary extends Component<Props, State> {
    unlisten: () => void;

    public override state: State = {
        error: null
    };

    override componentDidMount(): void {
        this.unlisten = this.props.history.listen(() => {
            this.props.reset();
            this.setState({ error: null });
        });
    }

    override componentWillUnmount(): void {
        this.unlisten?.();
    }

    override componentDidCatch(error: Error, _: ErrorInfo): void {
        void TrackingService.trackError(error);
    }

    public static getDerivedStateFromError(e: Error): State {
        // Update state so the next render will show the fallback UI.
        return { error: e };
    }

    public override render(): ReactNode {
        if (this.state.error) {
            if (this.state.error instanceof ApiError) {
                if (this.state.error.response.status === 401 && !this.props.isMobileApp) {
                    LogoutService.handleLogoutRedirect();
                    return null;
                } else if (this.state.error.response.status === 403) {
                    window.location.href = getSpendsmartLandingPageUrl();
                    return null;
                }
            }

            return (
                <ErrorView
                    error={this.state.error}
                    reset={() => {
                        this.props.reset();
                        this.setState({ error: null });
                    }}
                />
            );
        }

        return this.props.children;
    }
}

export default withRouter(ErrorBoundary);
